'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultThunkValue = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var dataShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _propTypes2.default.any;
  return _propTypes2.default.shape({
    loading: _propTypes2.default.bool.isRequired,
    loaded: _propTypes2.default.bool.isRequired,
    data: dataShape,
    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool])
  });
};

var defaultThunkValue = exports.defaultThunkValue = function defaultThunkValue() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    loading: false,
    loaded: false,
    data: defaultValue
  };
};